<section class="therapies-list-wrapper">
  <ng-container *ngIf="therapies && therapies.length >0">
    <p-accordion [multiple]="true" expandIcon="icon__expand" collapseIcon="icon__collapse">
      <gen-therapy-card
        class="Auto_Therapy_Match_list_Item"
        *ngFor="let therapy of therapies"
        [therapy]="therapy"
        [opinion]="opinion"
        [drugsList]="drugsList"
        [uncharacterizedTitle]="uncharacterizedTitle"
        [uncharacterizedIconClass]="uncharacterizedIconClass"
        [workflowInputs]="workflowInputs"
        [activeJobName]="activeJobName"
        [revisionId]="revisionId"
        [trials]="getTrials(therapy)"
        [caseStatus]="caseStatus"
        [isWildTypeTherapyMatch]="isWildTypeTherapyMatch(therapy)"
      ></gen-therapy-card>
    </p-accordion>
  </ng-container>
  <span *ngIf="!(therapies && therapies.length > 0)"> {{emptyMessage}}</span>
</section>
